export class PayloadEstruturaArmazenagemPeriodoModel {
    id: number;
    dataInicio: string;
    dataFim: string;
}
